import { render, staticRenderFns } from "./WallDesigner.vue?vue&type=template&id=2ccc1121"
import script from "./WallDesigner.vue?vue&type=script&lang=js"
export * from "./WallDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports